export const svgIconBackgroundStyle = { background: '#4CAF50' };
export const svgIconWithoutBackgroundStyle = { color: '#4CAF50', fontWeight: 'bold' };
export const svgIconTextStyle = { color: 'white' };
